import { Alert, Box, Checkbox, FormControlLabel, Grid2, Typography } from "@mui/material";
import { FormEvent, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Link, redirect, useNavigate } from "react-router-dom";
import { BrandEnum } from "../../_common/enum/brand.enum";
import { StandardButton } from "../../_components/button/primary.button";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { accountService } from "../../_services/accounts.service";
import { authScreenStyles } from "../../_styles/authScreen.styles";
import { AuthLogo } from "./_components/authLogo";

export function LoginIndex(params: {brand: BrandEnum}) {

    let navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");

        accountService.login(username, password, rememberMe)
            .then(
                ((item: any) => {
                    const token = item?.token ?? item?.Token;
                    const uname = item?.username ?? item?.Username;
                    if (token) {
                        navigate("/");
                    } else if (uname != null && uname !== "") {
                        navigate("/login/verifycode/username=" + encodeURIComponent(uname));
                    } else {
                        setErrorMsg("Username or password is incorrect");
                    }
                }),
                ((err) => {
                    if (err === 'Username or password is incorrect') { setErrorMsg(err); }
                    else if(typeof err === 'string' && err.trim() !== '') {setErrorMsg(err)}
                    else { toastr.error("Something went wrong. Please try again later"); }
                }))
            .finally(() => { setLoading(false); });
    }

    if (accountService.currentUserValue) {
        redirect('/users');
    }

    return (
        <>
            <AuthLogo brand={params.brand} />

            {/* <Typography variant="h3" sx={authScreenStyles.heading}>
                Welcome Back
            </Typography> */}

            <Typography sx={authScreenStyles.subheading}>
                Log in to your account
            </Typography>

            {errorMsg && (
                <Alert sx={authScreenStyles.alert} severity="error">
                    {errorMsg}!
                </Alert>
            )}

            <ValidatorForm onSubmit={submit} noValidate style={authScreenStyles.form}>
                <Grid2 container spacing={2} sx={authScreenStyles.formContainer}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            required
                            fullWidth
                            label="Username"
                            name="username"
                            value={username}
                            disabled={isLoading}
                            onChange={(e: any) => setUsername(e.target.value.toString())}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                            autoFocus
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            disabled={isLoading}
                            value={password}
                            onChange={(e: any) => setPassword(e.target.value.toString())}
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                            autoComplete="current-password"
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label="Remember me"
                            disabled={isLoading}
                            checked={rememberMe}
                            onChange={() => setRememberMe(!rememberMe)}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardButton
                            type="submit"
                            variant="primary"
                            loading={isLoading}
                            icon={"login"}>
                            Log In
                        </StandardButton>
                    </Grid2>
                </Grid2>
            </ValidatorForm>

            <Box sx={authScreenStyles.linkContainer}>
                <Link style={authScreenStyles.link} to="forgotpassword">
                    Forgot Password
                </Link>
            </Box>

        </>
    );
}